import httpClient from './httpClient'

const SystemOwnerApi = {
  async getList(pageNo, pageSize) {
    try {
      const res = await httpClient.get('/system_owner', {
        pageNo: pageNo,
        pageSize: pageSize,
      })
      return res.data
    } catch (e) {
      console.log(e)
      throw e
    }
  },
}

export default SystemOwnerApi
